import React, { ReactElement, ReactNode } from "react";
import { FormControlLabel } from "@mui/material";
import styles from "@/components/tables/fields/crudField.module.css";

interface PickerFormControlLabelProps {
  header: ReactNode;
  required?: boolean;
  children: ReactElement;
}

const PickerFormControlLabel = ({
  header,
  required,
  children,
}: PickerFormControlLabelProps) => (
  <FormControlLabel
    labelPlacement="top"
    sx={{
      margin: "0 ",
      width: "100%",
      alignItems: "start",
      fontFamily: "inherit !important",
    }}
    disableTypography
    label={
      <section style={{ margin: "0 0 0.25rem" }}>
        {header}
        {required && <span className={styles.labelRequired}>{"\u{002A}"}</span>}
      </section>
    }
    control={children}
  />
);

export default PickerFormControlLabel;
